import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import PrintPurchaseOrder from "./PrintPurchaseOrder";
import { useDispatch, useSelector } from "react-redux";
import { useLoadPartCandidatePoOrdersQuery } from "../../app/store/partnerApiSlice";
import {
  getCurrentUser,
  getLoggedUserDetails,
  loadUserDetails,
} from "../../app/store/auth";
import {
  getPoOrderDocumentData,
  loadPoOrderdownloadDocument,
  poOrderDownloadDataRecevied,
} from "../../app/store/documents";
import config from "../../config.json";
import { getAlert } from "../../Services/appAlerts";


const PURCHASE_ORDER_STYLES = {
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)"
  },
  headerRow: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  titleIcon: {
    width: "42px",
    height: "42px",
    borderRadius: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    border: "1px solid rgba(191, 219, 254, 1)",
    color: "#1d4ed8",
    fontSize: "17px",
    flexShrink: 0
  },
  eyebrow: {
    margin: "0 0 3px",
    color: "#4f46e5",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase"
  },
  title: {
    margin: 0,
    color: "#0f172a",
    fontSize: "20px",
    fontWeight: 800,
    lineHeight: 1.15
  },
  subtitle: {
    margin: "4px 0 0",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px"
  },
  summaryCard: {
    borderRadius: "16px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    background: "#ffffff",
    padding: "13px 14px",
    boxShadow: "0 10px 24px rgba(37, 99, 235, 0.06)"
  },
  summaryLabel: {
    margin: "0 0 6px",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  summaryValue: {
    margin: 0,
    color: "#0f172a",
    fontSize: "22px",
    fontWeight: 800,
    lineHeight: 1.1
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "12px"
  },
  toolbarText: {
    margin: 0,
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap"
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap"
  },
  tableShell: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "16px",
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
  },
  table: {
    marginBottom: 0
  },
  tableHeadCell: {
    borderTop: "none",
    background: "#f8fafc",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    padding: "13px 14px",
    textTransform: "uppercase",
    verticalAlign: "top"
  },
  tableCell: {
    borderTop: "1px solid rgba(241, 245, 249, 1)",
    background: "#ffffff",
    color: "#334155",
    fontSize: "13px",
    padding: "16px 14px",
    verticalAlign: "middle"
  },
  idPill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "34px",
    height: "30px",
    borderRadius: "999px",
    backgroundColor: "#f1f5f9",
    color: "#475569",
    fontSize: "12px",
    fontWeight: 800
  },
  actionButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "7px",
    borderRadius: "999px",
    border: "1px solid rgba(224, 231, 255, 1)",
    background: "#eef2ff",
    color: "#4338ca",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
    textDecoration: "none",
    whiteSpace: "nowrap",
    lineHeight: 1.2
  },
  statusPillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    borderRadius: "999px",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid transparent",
    marginBottom: "7px"
  },
  successPill: {
    color: "#166534",
    backgroundColor: "#f0fdf4",
    borderColor: "rgba(187, 247, 208, 1)"
  },
  warningPill: {
    color: "#92400e",
    backgroundColor: "#fffbeb",
    borderColor: "rgba(253, 230, 138, 1)"
  },
  mutedText: {
    display: "block",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  emptyState: {
    padding: "34px 20px",
    textAlign: "center",
    color: "#64748b",
    backgroundColor: "#ffffff"
  },
  emptyIcon: {
    width: "54px",
    height: "54px",
    margin: "0 auto 12px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
    color: "#2563eb",
    fontSize: "22px"
  },
  emptyTitle: {
    margin: "0 0 6px",
    color: "#0f172a",
    fontSize: "16px",
    fontWeight: 800
  },
  emptyText: {
    margin: 0,
    color: "#64748b",
    fontSize: "13px",
    lineHeight: 1.5
  },
  modalFooter: {
    padding: "14px 22px 18px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800,
  },
  cardList: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  poCard: {
    display: "grid",
    gridTemplateColumns: "38px minmax(0, 1fr) auto",
    alignItems: "center",
    gap: "14px",
    padding: "16px",
    background: "#ffffff",
    border: "1px solid #dbe3ef",
    borderRadius: "10px",
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.03)",
  },
  poIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "8px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#2563eb",
    border: "1px solid #dbeafe",
    fontSize: "16px",
  },
  poTitleLine: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
  },
  poName: {
    color: "#0f172a",
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: 1.25,
  },
  poMeta: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginTop: "6px",
    color: "#64748b",
    fontSize: "12px",
    fontWeight: 600,
  },
  poMetaItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    minWidth: 0,
    maxWidth: "320px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  poActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    minWidth: "520px",
  },
  poButton: {
    minHeight: "38px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    background: "#ffffff",
    border: "1px solid #cbd5e1",
    padding: "8px 16px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#475569",
    whiteSpace: "nowrap",
  },
  poViewButton: {
    minHeight: "26px",
    height: "26px",
    padding: "3px 9px",
    fontSize: "11.5px",
    borderRadius: "7px",
  },
  poPrimaryButton: {
    background: "#2563eb",
    color: "#ffffff",
    borderColor: "#2563eb",
  },
  poStatusStack: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
  },
  poStatusDate: {
    color: "#94a3b8",
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: 1.1,
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  poDivider: {
    width: "1px",
    height: "24px",
    background: "#cbd5e1",
    margin: "0 4px",
  },
  poEsignTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    width: "fit-content",
    padding: "2px 8px",
    borderRadius: "99px",
    background: "rgba(37, 99, 235, 0.08)",
    border: "1px solid rgba(37, 99, 235, 0.15)",
    color: "#1d4ed8",
    fontSize: "11px",
    fontWeight: 700,
  },
};

const PurchaseOrders = (props) => {
  const {
    handlePoShowHide,
    poShowHide,
    candidateObj,
    handleRefreshPartnerCandidates,
  } = props;

  const [poAction, setPoAction] = useState("");
  const [genShowHide, setGenShowHide] = useState(false);
  const [selectedPoOrder, setSelectedPoOrder] = useState(null);
  const [poSignLinkLoadingId, setPoSignLinkLoadingId] = useState(null);
  const [poEsignLinks, setPoEsignLinks] = useState({});

  const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
  const poOrderDocumentDataSelector = useSelector(getPoOrderDocumentData);

  const userType = useMemo(() => localStorage.getItem("userType"), []);
  const dispatch = useDispatch();
  const currentUser = useMemo(() => getCurrentUser(), []);
  const currentUserId = currentUser?.id;

  const getEsignBaseUrl = useCallback(() => {
    return window.location.hostname === "localhost"
      ? "http://localhost:5173"
      : (process?.env?.REACT_APP_ESIGN_BASEURL || "http://localhost:5173");
  }, []);

  const getEsignApiBaseUrl = useCallback(() => {
    return process?.env?.REACT_APP_ESIGN_API_BASEURL ||
      process?.env?.REACT_APP_ESIGN_API_URL ||
      (window.location.hostname === "localhost" ? "http://localhost:5005" : getEsignBaseUrl());
  }, [getEsignBaseUrl]);

  const getWorkbenchApiBaseUrl = useCallback(() => {
    return (process?.env?.REACT_APP_API_BASEURL || "").replace(/\/$/, "");
  }, []);

  const getPoEsignValue = useCallback((poOrder, key) => {
    return poOrder?.[key] ?? poOrder?.[`e${key.substring(1)}`] ?? poOrder?.[`esign${key.replace(/^ESign/, "")}`];
  }, []);

  const getPoEsignDocumentId = useCallback((poOrder) => {
    return getPoEsignValue(poOrder, "ESignDocumentId") || poOrder?.eSignDocumentId || poOrder?.esignDocumentId;
  }, [getPoEsignValue]);

  const getPoEsignPreparationToken = useCallback((poOrder) => {
    return getPoEsignValue(poOrder, "ESignPreparationToken") || poOrder?.eSignPreparationToken || poOrder?.esignPreparationToken;
  }, [getPoEsignValue]);

  const getPoEsignStatus = useCallback((poOrder) => {
    return getPoEsignValue(poOrder, "ESignStatus") || poOrder?.eSignStatus || poOrder?.esignStatus;
  }, [getPoEsignValue]);

  const isPoEsignSigned = useCallback((poOrder) => {
    const status = (getPoEsignStatus(poOrder) || "").replace(/\s+/g, "").toLowerCase();
    return status === "signed" || status === "completed" || !!getPoEsignValue(poOrder, "ESignCompletedDateTime");
  }, [getPoEsignStatus, getPoEsignValue]);

  const hasCurrentUserSignedPo = useCallback((poOrder) => {
    const status = (poOrder?.currentUserSignStatus || "").replace(/\s+/g, "").toLowerCase();
    return status === "signed" || status === "completed";
  }, []);

  const getPoBadge = useCallback((poOrder) => {
    const esignToken = getPoEsignPreparationToken(poOrder);
    const esignDocumentId = getPoEsignDocumentId(poOrder);
    const status = getPoEsignStatus(poOrder);
    const normalized = (status || "").replace(/\s+/g, "").toLowerCase();

    if (esignToken || esignDocumentId) {
      switch (normalized) {
        case "signed":
        case "completed":
          return { text: "Signed", icon: "fa-check-circle", style: PURCHASE_ORDER_STYLES.successPill };
        case "partiallysigned":
          return { text: "Partially Signed", icon: "fa-adjust", style: PURCHASE_ORDER_STYLES.warningPill };
        case "expired":
        case "cancelled":
        case "canceled":
        case "rejected":
          return { text: status, icon: "fa-exclamation-circle", style: { color: "#b91c1c", backgroundColor: "#fef2f2", borderColor: "#fecaca" } };
        default:
          return { text: "Pending Signature", icon: "fa-pencil-square-o", style: { color: "#1d4ed8", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" } };
      }
    }

    return poOrder.partnerSignedData
      ? { text: "Signed", icon: "fa-check-circle", style: PURCHASE_ORDER_STYLES.successPill }
      : null;
  }, [getPoEsignPreparationToken, getPoEsignDocumentId, getPoEsignStatus]);

  const usrType = useMemo(() => {
    if (userType !== "PP") return userType;
    if (!loggedUserDetailsSelector) return "";
    let uType = loggedUserDetailsSelector.partnerType;
    if (uType === "Sub-Contractors") {
      uType = "subcontractor";
    }
    return uType;
  }, [userType, loggedUserDetailsSelector]);

  useEffect(() => {
    if (userType === "PP" && !loggedUserDetailsSelector && currentUserId) {
      dispatch(loadUserDetails(currentUserId));
    }
  }, [dispatch, userType, loggedUserDetailsSelector, currentUserId]);

  const skipPoQuery = !candidateObj?.performerid || !usrType;
  const { data: purchaseOrders = [], refetch: refetchPoOrders } = useLoadPartCandidatePoOrdersQuery(
    { id: candidateObj?.performerid, type: usrType, currentPerformerId: currentUserId },
    { skip: skipPoQuery }
  );

  useEffect(() => {
    const fetchLinks = async () => {
      const newLinks = {};
      let updated = false;
      for (const item of purchaseOrders) {
        const esignToken = getPoEsignPreparationToken(item);
        if (esignToken) {
          let alreadyExists = false;
          setPoEsignLinks(prev => {
            if (prev[item.id]) {
              alreadyExists = true;
            }
            return prev;
          });

          if (!alreadyExists) {
            try {
              const apiBase = getWorkbenchApiBaseUrl();
              const response = await fetch(`${apiBase}/api/ReviewForm/GetPoESignLinks?poId=${item.id}`);
              if (response.ok) {
                const data = await response.json();
                newLinks[item.id] = data;
                updated = true;
              }
            } catch (error) {
              console.error("Error fetching PO esign links", error);
            }
          }
        }
      }
      if (updated) {
        setPoEsignLinks(prev => ({ ...prev, ...newLinks }));
      }
    };

    if (purchaseOrders.length > 0) {
      fetchLinks();
    }
  }, [purchaseOrders, getPoEsignPreparationToken, getWorkbenchApiBaseUrl]);

  const handleGenShowHide = useCallback((obj, action) => {
    if (obj === "save") {
      setGenShowHide(false);
      setPoAction("");
      setSelectedPoOrder(null);
      refetchPoOrders();
      if (handleRefreshPartnerCandidates) {
        handleRefreshPartnerCandidates();
      }
    } else {
      setGenShowHide(prev => !prev);
      setPoAction(action);
      setSelectedPoOrder(obj);
    }
  }, [refetchPoOrders, handleRefreshPartnerCandidates]);

  const handleDownloadFile = useCallback((item, type) => {
    dispatch(loadPoOrderdownloadDocument(item.id, type));
  }, [dispatch]);

  const handleViewPoFile = useCallback((item, type = "") => {
    const apiBaseUrl = getWorkbenchApiBaseUrl();
    const viewUrl = `${apiBaseUrl}/api/${config.GetPoOrderDocument}${item.id}&type=${encodeURIComponent(type)}&inline=true`;
    window.open(viewUrl, "_blank");
  }, [getWorkbenchApiBaseUrl]);

  const handleOpenPoSignLink = useCallback(async (item) => {
    const esignToken = getPoEsignPreparationToken(item);
    if (!esignToken) return;

    try {
      setPoSignLinkLoadingId(item.id);

      // The email lets the API resolve this specific signer, which is what enforces
      // the signing order for sequential purchase orders.
      const userEmail =
        loggedUserDetailsSelector?.performeremail ||
        loggedUserDetailsSelector?.performerEmail ||
        loggedUserDetailsSelector?.email ||
        currentUser?.email ||
        currentUser?.username ||
        currentUser?.unique_name ||
        "";

      const response = await fetch(
        `${getWorkbenchApiBaseUrl()}/api/ReviewForm/GetPoESignSignLink?poId=${item.id}&email=${encodeURIComponent(userEmail)}`
      );
      const data = await response.json().catch(() => null);

      if (!response.ok || !data?.signingLink) {
        getAlert("", data?.message || "Unable to create signing link.", "error");
        return;
      }

      window.open(data.signingLink, "_blank");
    } catch (error) {
      getAlert("", "Unable to connect to eSign. Please try again.", "error");
    } finally {
      setPoSignLinkLoadingId(null);
    }
  }, [getPoEsignPreparationToken, getWorkbenchApiBaseUrl, loggedUserDetailsSelector, currentUser]);

  useEffect(() => {
    if (poOrderDocumentDataSelector?.uploadUrl) {
      window.open(poOrderDocumentDataSelector?.uploadUrl, "_blank");
      dispatch(poOrderDownloadDataRecevied(null));
    }
  }, [poOrderDocumentDataSelector, dispatch]);

  const handlePoRefresh = useCallback(() => {
    refetchPoOrders();
  }, [refetchPoOrders]);

  const signedCount = useMemo(() => {
    return purchaseOrders.filter((item) => item.partnerSignedData || isPoEsignSigned(item)).length;
  }, [purchaseOrders, isPoEsignSigned]);

  const pendingCount = useMemo(() => {
    return purchaseOrders.filter((item) => !item.partnerSignedData && !isPoEsignSigned(item)).length;
  }, [purchaseOrders, isPoEsignSigned]);

  const candidateName = useMemo(() => {
    return [candidateObj?.performername, candidateObj?.lastName]
      .filter(Boolean)
      .join(" ");
  }, [candidateObj]);

  const renderPurchaseOrderCard = useCallback((item) => {
    const esignToken = getPoEsignPreparationToken(item);
    const esignDocumentId = getPoEsignDocumentId(item);
    const esignApiBaseUrl = getEsignApiBaseUrl();
    const esignSigned = isPoEsignSigned(item);
    const currentUserSigned = hasCurrentUserSignedPo(item);
    const documentSigned = esignSigned || !!item.partnerSignedData;
    const badge = getPoBadge(item);
    const signDate = getPoEsignValue(item, "ESignCompletedDateTime") || item.partnerSignDateTime;

    return (
      <div key={item.id} style={PURCHASE_ORDER_STYLES.poCard}>
        <div style={PURCHASE_ORDER_STYLES.poIcon}>
          <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
        </div>

        <div>
          <div style={PURCHASE_ORDER_STYLES.poTitleLine}>
            <span style={PURCHASE_ORDER_STYLES.poName}>Purchase Order #{item.id}</span>
            <button
              type="button"
              style={{ ...PURCHASE_ORDER_STYLES.poButton, ...PURCHASE_ORDER_STYLES.poViewButton }}
              onClick={() => handleViewPoFile(item, "")}
            >
              <i className="fa fa-download" aria-hidden="true"></i> View
            </button>
          </div>
          <div style={PURCHASE_ORDER_STYLES.poMeta}>
            <span style={PURCHASE_ORDER_STYLES.poMetaItem}>
              <i className="fa fa-calendar" aria-hidden="true"></i>
              <Moment format="MMM Do YYYY">{item.addedDateTime}</Moment>
            </span>
            <span style={PURCHASE_ORDER_STYLES.poMetaItem}>
              <i className="fa fa-clock-o" aria-hidden="true"></i>
              <Moment format="h:mm a">{item.addedDateTime}</Moment>
            </span>
            {item.ipcsPoName && (
              <span style={PURCHASE_ORDER_STYLES.poMetaItem}>
                <i className="fa fa-file-o" aria-hidden="true"></i> {item.ipcsPoName}
              </span>
            )}
            {(esignToken || esignDocumentId) && (
              <span style={PURCHASE_ORDER_STYLES.poEsignTag}>
                <i className="fa fa-pencil-square-o" aria-hidden="true"></i> eSign
              </span>
            )}
          </div>
        </div>

        <div style={PURCHASE_ORDER_STYLES.poActions}>
          <span style={PURCHASE_ORDER_STYLES.poStatusStack}>
            {badge && (
              <span style={{ ...PURCHASE_ORDER_STYLES.statusPillBase, ...badge.style, marginBottom: 0 }}>
                <i className={`fa ${badge.icon}`} aria-hidden="true"></i> {badge.text}
              </span>
            )}
            {signDate && (
              <span style={PURCHASE_ORDER_STYLES.poStatusDate}>
                <Moment format="MMM Do YYYY">{signDate}</Moment> · <Moment format="h:mm a">{signDate}</Moment>
              </span>
            )}
          </span>

          <span style={PURCHASE_ORDER_STYLES.poDivider}></span>

          {documentSigned ? (
            esignToken ? (
              <a
                style={PURCHASE_ORDER_STYLES.poButton}
                href={poEsignLinks[item.id]?.finalSigned || `${esignApiBaseUrl}/api/public/documents/${esignToken}/download/final-signed?inline=true`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-certificate" aria-hidden="true"></i> Download Signed Document
              </a>
            ) : (
              <button
                type="button"
                style={PURCHASE_ORDER_STYLES.poButton}
                onClick={() => handleDownloadFile(item, "partner")}
              >
                <i className="fa fa-certificate" aria-hidden="true"></i> Download Signed Document
              </button>
            )
          ) : esignToken && currentUserSigned ? (
            // This user has signed but other signers are still pending, so the final
            // signed PDF does not exist yet. Offer the visible signed copy (view only).
            <a
              style={PURCHASE_ORDER_STYLES.poButton}
              href={poEsignLinks[item.id]?.visibleSigned || `${esignApiBaseUrl}/api/public/documents/${esignToken}/download/visible-signed?inline=true`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-eye" aria-hidden="true"></i> View Signed Document
            </a>
          ) : esignToken ? (
            <button
              type="button"
              style={{ ...PURCHASE_ORDER_STYLES.poButton, ...PURCHASE_ORDER_STYLES.poPrimaryButton }}
              onClick={() => handleOpenPoSignLink(item)}
              disabled={poSignLinkLoadingId === item.id}
            >
              {poSignLinkLoadingId === item.id ? (
                <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Opening...</>
              ) : (
                <><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Sign the Document</>
              )}
            </button>
          ) : null}
        </div>
      </div>
    );
  }, [getPoEsignPreparationToken, getPoEsignDocumentId, getEsignApiBaseUrl, isPoEsignSigned, hasCurrentUserSignedPo, getPoBadge, getPoEsignValue, handleViewPoFile, poEsignLinks, poSignLinkLoadingId, handleOpenPoSignLink, handleDownloadFile]);

  return (
    <React.Fragment>
      <Modal show={poShowHide} size="xl" centered onHide={() => handlePoShowHide("")}>
        <Modal.Header style={PURCHASE_ORDER_STYLES.modalHeader}>
          <div style={PURCHASE_ORDER_STYLES.headerRow}>
            <Modal.Title as="div" style={PURCHASE_ORDER_STYLES.titleWrap}>
              <span style={PURCHASE_ORDER_STYLES.titleIcon}>
                <i className="fa fa-file-text-o" aria-hidden="true"></i>
              </span>
              <div>
                <p style={PURCHASE_ORDER_STYLES.eyebrow}>Purchase Orders</p>
                <h2 style={PURCHASE_ORDER_STYLES.title}>
                  {candidateName || "Candidate Purchase Orders"}
                </h2>
                <p style={PURCHASE_ORDER_STYLES.subtitle}>
                  Review, download, and complete pending eSign purchase orders.
                </p>
              </div>
            </Modal.Title>
            <button
              type="button"
              style={PURCHASE_ORDER_STYLES.closeButton}
              onClick={() => handlePoShowHide("")}
              aria-label="Close purchase orders popup"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body style={PURCHASE_ORDER_STYLES.modalBody}>
          <div style={PURCHASE_ORDER_STYLES.summaryGrid}>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Total Orders</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{purchaseOrders.length}</p>
            </div>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Pending eSign</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{pendingCount}</p>
            </div>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Signed</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{signedCount}</p>
            </div>
          </div>
          <div style={PURCHASE_ORDER_STYLES.toolbar}>
            <p style={PURCHASE_ORDER_STYLES.toolbarText}>
              Purchase order documents open in a new tab. Signed copies are available after eSign is complete.
            </p>
            <button
              className="btn btn-sm"
              style={PURCHASE_ORDER_STYLES.refreshButton}
              onClick={handlePoRefresh}
            >
              <i className="fa fa-refresh" aria-hidden="true"></i> Refresh
            </button>
          </div>
          {purchaseOrders.length === 0 ? (
            <div style={PURCHASE_ORDER_STYLES.emptyState}>
              <div style={PURCHASE_ORDER_STYLES.emptyIcon}>
                <i className="fa fa-file-text-o" aria-hidden="true"></i>
              </div>
              <h4 style={PURCHASE_ORDER_STYLES.emptyTitle}>No purchase orders found</h4>
              <p style={PURCHASE_ORDER_STYLES.emptyText}>
                Purchase orders will appear here once they are generated and sent for this candidate.
              </p>
            </div>
          ) : (
            <div style={PURCHASE_ORDER_STYLES.cardList}>
              {purchaseOrders.map((item) => renderPurchaseOrderCard(item))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={PURCHASE_ORDER_STYLES.modalFooter}>
          <div style={PURCHASE_ORDER_STYLES.footerActions}>
            <button
              type="button"
              style={PURCHASE_ORDER_STYLES.cancelButton}
              onClick={() => handlePoShowHide("")}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {genShowHide && candidateObj?.performerid > 0 && (
        <PrintPurchaseOrder
          genShowHide={genShowHide}
          handleGenShowHide={handleGenShowHide}
          candidateObj={candidateObj}
          poOrder={selectedPoOrder}
          poAction={poAction}
        ></PrintPurchaseOrder>
      )}
    </React.Fragment>
  );
};

export default PurchaseOrders;
